<header id="page-topbar">
    <div class="navbar-header">
        <div class="d-flex">
            <!-- LOGO -->
            <div class="navbar-brand-box">
                <a href="/" class="logo logo-dark">
                    <span class="logo-sm">
                        <!-- <img src="assets/images/logo-dark.png" alt="" class="logo-img" height="22" /> -->
                    </span>
                    <span class="logo-lg">
                        <img src="assets/images/logo-dark.png" alt="" class="logo-img" height="30" />
                    </span>
                </a>
                <a href="/" class="logo logo-light">
                    <span class="logo-sm">
                        <!-- <img src="assets/images/logo.png" alt="" class="logo-img" height="22" /> -->
                    </span>
                    <span class="logo-lg">
                        <img src="assets/images/logo-dark.png" alt="" class="logo-img" height="40" />
                    </span>
                </a>
            </div>
            <div style="margin: auto 20px;">
                <h4 class="mb-0 font-size-18" >{{title}}</h4>
            </div>
        </div>
        <div class="d-flex align-items-center">
            <!-- WhatsApp / Connect Channel -->
            <!-- <div class="d-inline-block">
                <button type="button" class="btn header-item connect-channel-btn" (click)="openConnectChannel(modalConnectChannel)"
                    [title]="(waConnected ? 'WhatsApp Terhubung' : 'Hubungkan WhatsApp') | translate">
                    <i class="fab fa-whatsapp"></i>
                    <span *ngIf="!waConnected" class="connect-channel-badge"><i class="fas fa-exclamation-circle"></i></span>
                </button>
            </div> -->
            <div class="dropdown d-inline-block" ngbDropdown>
                <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
                    <i class="fa fa-user user-avatar"></i>
                    <span class="d-none d-xl-inline-block ml-1">{{user.nama}}</span>
                    <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
                     <a class="dropdown-item d-block" href="javascript: void(0);"  (click)="gantiPassword(modalGPassword)">
                        <i class="bx bx-wrench font-size-16 align-middle mr-1"></i>
                        Ganti Password
                    </a>
                    <div class="dropdown-divider"></div>
                    <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()">
                        <i class=" bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
                        Logout
                    </a>
                </div>
            </div>
        </div>
    </div>
</header>
<ng-template #modalGPassword let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0">Ganti Password</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">Password</label>
                    <div class="col-md-8">
                        <input class="form-control form-control-sm" type="password" [(ngModel)]="model.password" name="password" placeholder="Masukkan Password Baru" />
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-4 col-form-label col-form-label-sm required">Ulangi Kata Sandi</label>
                    <div class="col-md-8">
                        <input class="form-control form-control-sm" type="password" [(ngModel)]="model.repassword" name="repassword" placeholder="Ulangi Kata Sandi Baru" />
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div class="float-right">
            <button class="btn btn-primary btn-sm" (click)="savepasswords(); modal.dismiss('Cross click')" [disabled]="model.password != model.repassword">
                <i class="fa fa-save font-size-14 align-middle mr-2"></i>
                Simpan
            </button>
        </div>
    </div>
</ng-template>

<!-- ============ CONNECT CHANNEL (WhatsApp) ============ -->
<ng-template #modalConnectChannel let-modal>
    <!-- Section: daftar konteks chat yang dapat dibalas AI Agent (dipakai di step QR & info) -->
    <ng-template #agentContextSection>
        <div class="text-left">
            <h6 class="font-weight-bold mb-1">{{ 'Konteks yang Dapat Dibalas Agent' | translate }}</h6>
            <small class="text-muted d-block mb-2">
                {{ 'Ditangani oleh' | translate }} {{ (connectModel && connectModel.aiAgent) || 'Humanis Agent' }}
            </small>
            <div class="list-group" style="max-height: 380px; overflow-y: auto;">
                <div class="list-group-item px-2 py-2" *ngFor="let ctx of agentContexts">
                    <div class="d-flex align-items-center" style="cursor: pointer;"
                        (click)="ctx.expanded = !ctx.expanded">
                        <div class="flex-grow-1 font-weight-medium font-size-13">{{ ctx.title | translate }}</div>
                        <i class="fas" [ngClass]="ctx.expanded ? 'fa-chevron-up' : 'fa-chevron-down'"
                            style="color: #74788d;"></i>
                    </div>
                    <div *ngIf="ctx.expanded" class="mt-2 pt-2 border-top">
                        <small class="text-muted d-block">{{ 'Deskripsi' | translate }}</small>
                        <small class="d-block mb-2">{{ ctx.desc | translate }}</small>
                        <small class="text-muted d-block">{{ 'Contoh Pesan' | translate }}</small>
                        <div class="bg-light rounded px-2 py-1 mt-1">
                            <small class="font-italic">"{{ ctx.sample }}"</small>
                        </div>
                        <small class="text-muted d-block mt-2">{{ 'Contoh Respon AI' | translate }}</small>
                        <div class="rounded px-2 py-1 mt-1" style="background: #e7f7ec;">
                            <small><i class="fab fa-whatsapp text-success mr-1"></i>{{ ctx.response }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <div class="modal-header">
        <h5 class="modal-title mt-0">{{ 'WhatsApp Agent' | translate }}</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <!-- ===== STEP 1 : Isi data channel ===== -->
    <ng-container *ngIf="connectStep === 1">
        <div class="modal-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label col-form-label-sm">{{ 'Platform' | translate }}</label>
                        <div class="col-md-8">
                            <input class="form-control form-control-sm" type="text" [value]="connectModel.platform"
                                name="ccPlatform" disabled readonly />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-4 col-form-label col-form-label-sm required">{{ 'Channel Name' | translate }}</label>
                        <div class="col-md-8">
                            <input class="form-control form-control-sm" type="text" [(ngModel)]="connectModel.channelName"
                                name="ccChannelName" placeholder="{{ 'Contoh: Humanis Hiraka' | translate }}"
                                autocomplete="off" />
                        </div>
                    </div>
                    <div class="form-group row mb-0">
                        <label class="col-md-4 col-form-label col-form-label-sm">{{ 'AI Agent' | translate }}</label>
                        <div class="col-md-8">
                            <input class="form-control form-control-sm" type="text" [value]="connectModel.aiAgent"
                                name="ccAiAgent" disabled readonly />
                            <small class="text-muted d-block mt-1">{{ 'The agent that will reply on this channel. You can change it later.' | translate }}</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <div class="float-right">
                <button type="button" class="btn btn-primary btn-sm" (click)="connectChannelNext()"
                    [disabled]="!connectModel.channelName">
                    <i class="fas fa-link font-size-14 align-middle mr-2"></i>
                    {{ 'Connect' | translate }}
                </button>
            </div>
        </div>
    </ng-container>

    <!-- ===== STEP 2 : Scan QR ===== -->
    <ng-container *ngIf="connectStep === 2">
        <div class="modal-body text-center">
            <h6 class="font-weight-bold d-inline-block border-bottom border-dark pb-2 mb-4">
                {{ 'Scan QR' | translate }}
            </h6>
            <div class="d-block">
                <div class="d-inline-block p-3 border rounded">
                    <img src="assets/images/dummy-qr.svg" alt="QR Code" style="width: 190px; height: 190px;" />
                </div>
            </div>
            <p class="text-muted mt-3 mb-2 px-3">
                {{ 'Open WhatsApp' | translate }} &rarr; {{ 'Linked Devices' | translate }} &rarr; {{ 'Link a Device' | translate }}, {{ 'then scan this code.' | translate }}
            </p>
            <div class="text-muted d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
                <span>{{ 'Waiting to be scanned...' | translate }}</span>
            </div>

            <hr class="my-3" />
            <!-- Konteks yang dapat dibalas Agent -->
            <ng-container *ngTemplateOutlet="agentContextSection"></ng-container>
        </div>
        <div class="modal-footer">
            <!-- Tombol simulasi (UI only) -->
            <button type="button" class="btn btn-success btn-sm" (click)="simulateConnected()">
                <i class="fas fa-check-circle font-size-14 align-middle mr-2"></i>
                {{ 'Simulasi Terhubung' | translate }}
            </button>
        </div>
    </ng-container>

    <!-- ===== STEP 4 : Info akun WhatsApp yang terhubung ===== -->
    <ng-container *ngIf="connectStep === 4">
        <div class="modal-body">
            <!-- Banner status terhubung -->
            <div class="d-flex align-items-center justify-content-between p-3 rounded"
                style="background: #e7f7ec; border: 1px solid #b7e4c7;">
                <div class="d-flex align-items-center">
                    <i class="fas fa-check-circle text-success mr-2" style="font-size: 24px;"></i>
                    <div>
                        <div class="font-weight-bold">{{ 'WhatsApp Terhubung' | translate }}</div>
                        <small class="text-muted">{{ 'Akun' | translate }}: {{ connectedInfo.accountName }} &bull; {{ connectedInfo.phone }}</small>
                    </div>
                </div>
                <button type="button" class="btn btn-outline-danger btn-sm" (click)="reconnectChannel()">
                    {{ 'Putuskan Koneksi' | translate }}
                </button>
            </div>
            <small class="text-muted d-block mt-2">{{ 'Dihubungkan pada' | translate }}: {{ connectedInfo.lastConnected }}</small>

            <hr class="my-3" />
            <!-- Konteks yang dapat dibalas Agent -->
            <ng-container *ngTemplateOutlet="agentContextSection"></ng-container>
        </div>
    </ng-container>
</ng-template>